import * as React from 'react';

export const SUCCESS_STUB_TEXTS = {
  CONGRATULATIONS: 'Поздравляем!',
  DESCRIPTION: (
    <>
      Вы&nbsp;успешно зарегистрировались в&nbsp;системе. Скоро вы&nbsp;будете
      перенаправлены на&nbsp;главную страницу сервиса.
    </>
  ),
};
